export default "__VITE_ASSET__DI3dXQsn__"